import { ConstraintCalendarRestrictionDetailBase } from './base/constraint-calendar-restriction-detail-base';

export class ConstraintCalendarRestrictionDetail extends ConstraintCalendarRestrictionDetailBase { }